/**
 * lib/views/javascripts/proto/chrome.js — what the Proto chrome does on a
 * page every Proto.render() draws (lib/proto/shell-chrome.js; ADR 0082 P3,
 * lv-1): it centres the global search between the title and the views box,
 * and routes the Relay box's tabs to the Proto's own pages.
 *
 * Moved as is from the two inline scripts shell-chrome.js appended to the
 * body. The tab router listens on document in the CAPTURE phase, so it
 * claims a tab click before the shell's own handler on the toggle (a bubble
 * listener) whichever registered first; running from a module, after the
 * parse, changes nothing about that.
 *
 * Contents: view
 * Ontology: Code object M33C-0734 (immutable ref — assigned once, never edit)
 * Team: J. Brant Arseneau & the Mach33 Agents.
 */

// ── Centred search ───────────────────────────────────────────────────────
// Move the search to sit BETWEEN the title and the view box (centre).
export function centreSearch() {
  setTimeout(function () {
    var s = document.getElementById('m33-global-search'),
      h = document.querySelector('.m33-header'), hr = h && h.querySelector('.m33-header-right');
    if (s && h && hr) { h.insertBefore(s, hr); }
  }, 350);
}

// ── Header switching → Proto routes ──────────────────────────────────────
// The Relay tab is Vega's in-page "posture" (data-manifold=team, href=#); a
// Proto serves Relay as /relay, so the tab click is intercepted in the
// CAPTURE phase (before Vega's bubble handler) and routed: Relay → /relay,
// Research → /chat. The active state is repainted by route.
export function routeRelayTabs() {
  function paint() {
    var mt = document.getElementById('m33-manifold-toggle'); if (!mt) return;
    var onRelay = location.pathname === '/relay';
    mt.querySelectorAll('[data-manifold]').forEach(function (a) {
      var m = a.getAttribute('data-manifold');
      a.classList.toggle('m33-active', onRelay ? (m === 'team') : (m === 'research'));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#m33-manifold-toggle [data-manifold]');
    if (!b) return;
    var m = b.getAttribute('data-manifold'); var dest = (m === 'team') ? '/relay' : '/chat';
    e.preventDefault(); e.stopImmediatePropagation();
    if (location.pathname !== dest) window.location.assign(dest);
  }, true);
  setTimeout(paint, 400); paint();
}

// ── Start ────────────────────────────────────────────────────────────────
export function mountProtoChrome() {
  centreSearch();
  routeRelayTabs();
}
